import { __assign } from "tslib";
import { createCustomHeadCodeApiApiTestKit } from './helpcenter/custom-head-code/testkit';
import { createCustomCssApiApiTestKit } from './helpcenter/custom-css/testkit';
import { createContentVisibilityApiTestKit } from './helpcenter/content-visibility/testkit';
import { createAuthSettingsApiTestKit } from './helpcenter/authentication/testkit';
import { createHelpcenterContactApiTestKit } from './helpcenter/contact/testkit';
import { createTextsApiTestKit } from './helpcenter/texts/testkit';
import { createFacebookApiTestKit } from './facebook/testkit';
import { createSettingsApi } from './index';
import { createHttpTestKit } from '../http/test-kit';
import { createApiKeysApiTestKit } from './api-keys/testkit';
import { createWebhooksApiTestKit } from './webhooks/testkit';
import { createEmailTemplatesApiTestKit } from './email-templates/testkit';
import { createSeoApiTestKit } from './helpcenter/seo/testkit';
import { createMailboxesApiTestKit } from './mailboxes/testkit';
import { createAccountSettingsApiTestKit } from './account/testkit';
import { createDesignApiTestKit } from './helpcenter/design/testkit';
import { createFeaturedArticlesApiTestKit } from './helpcenter/featured-articles/testkit';
import { createDomainApiTestKit } from './helpcenter/domain/testkit';
import { createCustomJsApiApiTestKit } from './helpcenter/custom-js/testkit';
import { createAppSettingsApiTestKit } from './app/testkit';
import { createCallcenterSettingsApiTestKit } from './callcenter/testkit';
import { createHeaderFooterSettingsApiApiTestKit } from './helpcenter/header-footer/testkit';
import { createRuleEngineApiTestKit } from './rule-engine/testkit';
import { createEmailDomainApiTestKit } from './email-notification/testkit';
import { createAutoAssignSettingsApiTestKit } from './auto-assign/testkit';
import { createStructureAndContentApiTestKit } from './helpcenter/structure-and-content/testkit';
import { createBrandingApiTestKit } from './helpcenter/branding/testkit';
import { createCsatSettingsApiTestKit } from './csat-settings/testkit';
import { createAutoRoutingApiTestkit } from './auto-routing/testkit';
import { createHelpCenterAccountApiTestKit } from './helpcenter/account/testkit';
import { createInAppNotificationApiTestKit } from './in-app-notification/testkit';
export var createSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSettingsApi('', fakeHttp);
    var testKit = {
        app: createAppSettingsApiTestKit(),
        mailboxes: createMailboxesApiTestKit(),
        account: createAccountSettingsApiTestKit(),
        inAppNotifications: createInAppNotificationApiTestKit(),
        tools: {
            apiKeys: createApiKeysApiTestKit(),
            webhooks: createWebhooksApiTestKit(),
            emailTemplates: createEmailTemplatesApiTestKit(),
            emailDomain: createEmailDomainApiTestKit(),
        },
        helpcenter: {
            structureAndContent: createStructureAndContentApiTestKit(),
            branding: createBrandingApiTestKit(),
            seo: createSeoApiTestKit(),
            design: createDesignApiTestKit(),
            texts: createTextsApiTestKit(),
            featuredArticles: createFeaturedArticlesApiTestKit(),
            domain: createDomainApiTestKit(),
            contact: createHelpcenterContactApiTestKit(),
            customCss: createCustomCssApiApiTestKit(),
            customJs: createCustomJsApiApiTestKit(),
            customHeadCode: createCustomHeadCodeApiApiTestKit(),
            headerFooter: createHeaderFooterSettingsApiApiTestKit(),
            auth: createAuthSettingsApiTestKit(),
            contentVisibility: createContentVisibilityApiTestKit(),
            account: createHelpCenterAccountApiTestKit()
        },
        callcenter: createCallcenterSettingsApiTestKit(),
        facebook: createFacebookApiTestKit(),
        rulesEngine: createRuleEngineApiTestKit(),
        autoAssign: createAutoAssignSettingsApiTestKit(),
        autoRouting: createAutoRoutingApiTestkit(),
        csat: createCsatSettingsApiTestKit()
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map